module.exports = __webpack_public_path__ + "img/foto25.7567ae81.jpg";